import React, { useEffect, useRef, useState } from "react";
import EditPoll from "../../../../components/EditPoll";

export default function EditPollModal(props) {
  const { poll, brand_name, updatePoll } = props;
  const closeBtnRef = useRef();
  const [currentPoll, setCurrentPoll] = useState({
    id: "",
    answers: [],
    media_type: "",
    media_url: "",
    question: "",
    hot_topic: "",
  });
  useEffect(() => {
    if (poll) {
      setCurrentPoll(poll);
    }
  }, [poll]);
  const onSave = (updatedPoll) => {
    if (closeBtnRef.current) {
      closeBtnRef.current.click();
    }
    updatePoll(updatedPoll);
  };
  return (
    <div
      className="modal fade poll_edit"
      id={`poll_edit_modal`}
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div
        className="modal-dialog"
        style={{ maxWidth: "800px" }}
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Poll </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              ref={closeBtnRef}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <EditPoll
            currentPoll={currentPoll}
            onSave={onSave}
            brand_name={brand_name}
          />
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Polls/components/EditPollModal/index.js